import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, AbstractControl } from "@angular/forms";
import { QueryParameter } from "../../base-models/query-parameter";
import { List } from "immutable";
import { DefgIniService } from "../../base-services/defg-ini.service";
import { BaseDataService } from "./../../base-services/base-data.service";

@Component({
  selector: "yt-print-dialog",
  templateUrl: "./print-dialog.component.html"
})
export class PrintDialog {
  constructor(
    private activeModal: NgbActiveModal
    , private defgIniService: DefgIniService
    , private baseDataService: BaseDataService
    ) {}

  collapsed: boolean = true;
  collapsedPageHeaderSettings: boolean = true;
  collapsedReportHeaderSettings: boolean = true;

  showNazivControl: boolean = false; // Ovo skloniti kada budemo hteli da se vidi kontrola Naziv na stampanju

  @Input() ShowFirmaZrc: boolean = false;
  @Input() ButtonsDisabled: boolean = false;

  @Input() set Title(value: string) {
    this.baseFormGroup.get("Title").setValue(value);
  }

  @Input() ShowAllInOneDoc: boolean = false;
  @Input() ShowEregistrator: boolean = false;

  @Input() PodvrstaDokumentaStavkaId: number=null;

  // @Input() DefaultReportHeaderType:string="TextOnly";

  parameterList: List<QueryParameter> = List([]);
  VrstaDokumentaID: QueryParameter = new QueryParameter();

  baseFormGroup: FormGroup = new FormGroup({
    Title: new FormControl(""),
    Subtitle: new FormControl(""),
    ShowPageCount: new FormControl(true),
    PageNoPosition: new FormControl("L"),
    ReportHeaderTypes: new FormControl("TextOnly"),
    ReportPageTypes: new FormControl("Memorandum"),
    FirmaZrcs: new FormControl(),
    AllInOneDoc: new FormControl(false),
    TipDokumenta: new FormControl(),
    Eregistrator: new FormControl(false)
  });

  ngOnInit(){
    this.VrstaDokumentaID.Name = "podVrstaDokumentaID";
    this.VrstaDokumentaID.Value = this.PodvrstaDokumentaStavkaId;
    this.parameterList = this.parameterList.push(this.VrstaDokumentaID);
    this.ShowEregistrator = this.defgIniService.GetByKey('g_eRegistrator');
    this.getDefaultIzvestajID();
    // this.baseFormGroup.patchValue({ReportHeaderTypes: this.DefaultReportHeaderType});
   
  }

  getDefaultIzvestajID() {
    if (this.PodvrstaDokumentaStavkaId) {
      this.baseDataService.Get("PodVrstaDokumentaStavka"
        , "getDefaultIzvestajIdByPodvrstaDokumentaStavkaId"
        , [new QueryParameter("podvrstaDokumentaStavkaId", this.PodvrstaDokumentaStavkaId)], null)
        .subscribe(data => {
          this.baseFormGroup.patchValue({ TipDokumenta: data })
        })
    }
  }

  get fc() {
    return this.baseFormGroup.controls;
  }

  Close() {
    this.activeModal.dismiss();
  }

  Print() {
    this.activeModal.close(this.baseFormGroup.value);
  }

  toggleCollapse() {
    this.collapsed = !this.collapsed;
  }

  toggleCollapsePageHeaderSettings() {
    this.collapsedPageHeaderSettings = !this.collapsedPageHeaderSettings;
  }

  toggleCollapseReportHeaderSettings() {
    this.collapsedReportHeaderSettings = !this.collapsedReportHeaderSettings;
  }
}
